import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";

const Possessivartikel4 = () => {
  const Title = [
    "ضمیر فاعلی",
    "مذکر - DES+S",
    "مونث - DER",
    "خنثی - DES+S",
    "جمع - DER",
  ];
  const ST1 = ["ICH", "meines", "meiner", "meines", "meiner"];
  const ST2 = ["DU", "deines", "deiner", "deines", "deiner"];
  const ST3 = ["ER", "seines", "seiner", "seines", "seiner"];
  const ST4 = ["SIE او", "ihres", "ihrer", "ihres", "ihrer"];
  const ST5 = ["ES", "seines", "seiner", "seines", "seiner"];
  const ST6 = ["WIR", "unseres", "unserer", "unseres", "unserer"];
  const ST7 = ["IHR شما - غیر رسمی", "eures", "eurer", "eures", "eurer"];
  const ST8 = ["SIE آنها", "ihres", "ihrer", "ihres", "ihrer"];
  const ST9 = ["Sie شما - محترمانه", "Ihres", "Irer", "Ihres", "Ihrer"];
  return (
    <Box className={classess.Wrapper}>
      <span>۴. ضمایر ملکی در حالت ملکی (Genitiv)</span>
      <Box className={classess.WP}>
        {Title.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                backgroundColor: "rgba(150, 150, 150, 0.1)",
                fontSize: "0.9rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST3.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST4.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr title={index === 3 || index === 1 ? "IIGHES" : "IGHA"}>
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST5.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST6.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
                cursor: index === 4 ? null : "pointer",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr title={index === 1 || index === 3 ? "ONZEGHES" : "ONZA"}>
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST7.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
                cursor: index === 4 ? null : "pointer",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 1 || index === 3
                      ? "AIGHES"
                      : index === 0
                      ? "AIGHA"
                      : "AIGHA"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST8.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 3
                      ? "IIGHES"
                      : index === 2
                      ? "IGHA"
                      : index === 1
                      ? "IIGHES"
                      : "IGHA"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST9.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.Footers}>
        <span>
          Genitiv : „{" "}
          <label className={classess.Label}>
            Das ist das Auto meines Bruders.
          </label>
          “
        </span>
        <span className={classess.Span}>( این ماشینِ برادرم است )</span>
        <span style={{ marginTop: "8px" }}>
          Genitiv : „{" "}
          <label className={classess.Label}>
            Das ist das Buch meiner Schwester.
          </label>
          “
        </span>
        <span className={classess.Span}>( ین کتابِ خواهرم است )</span>
      </Box>
    </Box>
  );
};

export default Possessivartikel4;
